<script lang="ts">
  import { Button, Col} from "sveltestrap";
  import { NewMessage, save } from "../../../../utils/Constant/Constant";
  import NewMessageFooter from "./NewMessageFooter.svelte";
  import NewMessageForm from "./NewMessageForm.svelte";
</script>
<Col xl=9 md="12" class="xl-70 box-col-8">
    <div class="email-right-aside">
        <div class="card email-body">
            <div class="email-profile">                                  
                <div class="email-body">                                        
                    <div class="email-compose">
                        <div class="email-top compose-border">     
                            <div class="compose-header">
                                <h4 class="mb-0">{NewMessage}</h4>
                                <Button color="primary"><i class="fa fa-file me-2"></i> {save}</Button>
                            </div>
                        </div>
                        <div class="email-wrapper">
                            <NewMessageForm />
                            <NewMessageFooter />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</Col>